import Logo from '../Logo/Logo';
import { useLocation } from 'react-router-dom';
import useBreakpoint from '@/hooks/useBreakpoint';

const ContentHeader = () => {
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoint();
  const height = isMobile ? '48px' : '55px';
  const logoType = pathname.startsWith('/card') ? 'akova-card' : 'akova-pay';

  return <Logo type={logoType} height={height} />;
};

export default ContentHeader;
